import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { FormattedNumberPropType } from '../../../prop-types/intl';
import messages from '../../../fulfillment-planner/labeled-row/messages';
import LabeledRow from '../../../fulfillment-planner/labeled-row';

import style from './style.module.less';

const Weight = ({ weight, showMdash = false }) => {
  return (
    <LabeledRow className={style.row} label={<FormattedMessage {...messages.weight} />} labelClassName={style.label}>
      {showMdash && <span className={style.mdash}>&mdash;</span>}
      {!showMdash && <span className={style.info}>{weight}</span>}
    </LabeledRow>
  );
};

Weight.propTypes = {
  weight: FormattedNumberPropType,
  showMdash: PropTypes.bool,
};

export default Weight;
